import { z } from 'zod'

export const GetDeviceNamesByUuidsVariablesSchema = z.object({
    uuids: z.array(z.string())
})

export type GetDeviceNamesByUuidsVariables = z.infer<typeof GetDeviceNamesByUuidsVariablesSchema>

export const GetDeviceNamesByUuidsQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    device: z.array(
        z.object({
            __typename: z.literal('device').optional(),
            uuid: z.string(),
            device_name: z.string().nullish(),
            type: z.string().nullish()
        })
    )
})

export type GetDeviceNamesByUuidsQuery = z.infer<typeof GetDeviceNamesByUuidsQuerySchema>
